import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../../../theme';

const cardStyles = (chart, sliderView) =>
  makeStyles((theme: Theme) =>
    createStyles({
      cardWithToggle: {
        cursor: 'pointer',

        '&:hover': {
          boxShadow: `0px 0px 0px 2px ${colorsPalette.blue}`,
        },
      },
      activeCard: {
        background: colorsPalette.blue,

        '&:hover': {
          boxShadow: 'none',
        },
      },
      cardHeadWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: sliderView ? 8 : 16,

        [theme.breakpoints.up('md')]: {
          marginBottom: 20,
        },
      },
      cardTitle: {
        color: colorsPalette.white,
      },
      cardBlock: {
        display: 'flex',
        flexDirection: sliderView ? 'row' : 'column',
        alignItems: sliderView ? 'flex-end' : 'stretch',
        justifyContent: 'space-between',

        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          alignItems: 'flex-end',
        },
      },
      cardChildren: {
        width: '100%',
        maxWidth: sliderView ? '50%' : '100%',
        display: chart ? 'block' : 'flex',
        justifyContent: 'flex-end',
        textAlign: 'right',
        height: sliderView ? 40 : 70,
        marginTop: sliderView ? '0 !important' : -70,

        '& img': {
          height: '100%',
          objectFit: 'contain',
        },

        [theme.breakpoints.up('md')]: {
          height: 70,
          marginTop: 0,
        },
      },
      expandIcon: {
        display: 'inline-flex',
        cursor: 'pointer',
      },
      decimal: {
        fontSize: 20,
      },
    }),
  );

export default cardStyles;
